import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    overflowY: 'auto'
  },
  ratePlansPaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '80%',
    maxWidth: 1000,
    padding: 24,
    marginTop: '8vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  editIcon: {
    margin: 'auto',
    fontSize: 70,
    position: 'absolute',
    backgroundColor: theme.palette.type === 'dark' ? '#121212' : '#7f7f7f',
    padding: 10,
    borderRadius: '50%',
    top: -41,
    left: 'calc(50% - 40px)'
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    margin: 32
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: '6fr 5fr 4fr 3fr',
    alignItems: 'center',
    padding: '6px 0 6px 12px',
    marginBottom: 4,
    marginTop: 12,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      padding: '6px 0 6px 0',
      gridTemplateColumns: '7fr 4fr '
    }
  },
  buttonsStyles: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 14
  },
  saveButton: {
    marginLeft: 12
  },
  inputWithLabel: {
    marginBottom: 10
  }
}))
export default useStyles
